<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'
    import type { Readable } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import { iconExclamationTriangle } from 'hydria/icons'
    import { gettext as _ } from 'hydria/services/gettext'
    import { spath } from 'hydria/svelte_helpers'

    import { Breadcrumb } from 'breadcrumb'

    import type { User, UserHandler } from './user'

    import ExtraMetaEditor from 'admin/components/ExtraMetaEditor.svelte'

    const userh = getContext('User') as UserHandler

    const status = sderived(userh.status, ($status) => $status)

    const userId = getContext('userId') as Readable<string>
    const user: Readable<User> = sderived(userh.userWritable, ($v) => $v)

    const crumbs = sderived(status, ($status) => [
        { txt: $_('Users'), url: spath('/wdom-users') },
        {
            txt: $status == 'ready' ? $user.email : $status == 'loading' ? '…' : iconExclamationTriangle,
            html: $status != 'ready' && $status != 'loading',
            url: spath(`/wdom-user/${$userId}`),
        },
        { txt: $_('Métadonnées supplémentaires') },
    ])
</script>

{#if $status == 'not-found' || $status == 'error'}
    <Breadcrumb {crumbs} />

    <div class="alert alert-danger">
        <Icon inline icon="fa:exclamation-triangle" />
        {#if $status == 'not-found'}
            {$_('The requested document does not exist.')}
        {:else}
            {$_('An error occured. Please try again in a moment.')}
        {/if}
    </div>
{:else}
    <ExtraMetaEditor {crumbs} {user} />
{/if}
